import React from 'react';
import { withTheme } from 'styled-components';

import Tooltip from 'ggApp/shared/containers/tooltip';
import { PureTranslator } from 'ggApp/modules/translator';

import {
    Container,
    PlanTypeWrap,
    PlanType,
    ContentWrap,
    PriceWrap,
    OldPrice,
    Price,
    PriceSuffix,
    SelectorHelpWrap,
    SelectorHelpText,
    SelectorHelpTriggerText,
    Selector,
    TrialDescription,
    Warning,
    Cta,
    Delivery,
    CardCheck,
} from './styles';

interface FlexibleProductCardProps {
    className?: string;
    theme: any;
    selectedMinDuration: number;
    oldPrice?: string;
    price: string;
    onCtaClick: () => void;
    selectFlow: () => void;
    inMixCartFlow: boolean;
    active: boolean;
    canSubscribe: boolean;
    preorderProduct?: any;
    deliveryEstimate?: { from: number; to: number };
    withTrialDescription: boolean;
    ctaTk: string;
}

export const FlexibleProductCard = withTheme(
    ({
        className,
        theme,
        selectedMinDuration,
        oldPrice,
        price,
        onCtaClick,
        selectFlow,
        inMixCartFlow,
        active,
        canSubscribe,
        preorderProduct,
        deliveryEstimate,
        withTrialDescription,
        ctaTk,
    }: FlexibleProductCardProps): JSX.Element => {
        return (
            <Container
                className={className}
                onClick={!active ? selectFlow : undefined}
                active={active}
            >
                <PlanTypeWrap active={active}>
                    <CardCheck
                        id="flex-rental-radio"
                        name="pdp-rental-option-radio"
                        dotColor={theme.colors.Foreground}
                        borderColor={theme.colors['Level 2']}
                        checked={active}
                    />
                    <PlanType>
                        <PureTranslator tk="MIX_FLEXIBLE_RENTAL_PLAN_LABEL" />
                    </PlanType>
                </PlanTypeWrap>
                {active ? (
                    <ContentWrap>
                        <PriceWrap>
                            {oldPrice ? <OldPrice>{oldPrice} </OldPrice> : null}
                            <Price withOldPrice={!!oldPrice}>{price}</Price>
                            <PriceSuffix>
                                <PureTranslator tk="PRODUCT_CARD_PLAN_PERIOD_LABEL_SHORT" />
                            </PriceSuffix>
                        </PriceWrap>
                        <SelectorHelpWrap>
                            <SelectorHelpText>
                                <PureTranslator tk="MIX_FLEXIBLE_SELECTOR_HELP_TEXT_START" />
                            </SelectorHelpText>
                            <Tooltip tooltipTK="MIX_FLEXIBLE_SELECTOR_HELP_TEXT_TOOLTIP">
                                <SelectorHelpTriggerText>
                                    <PureTranslator tk="MIX_FLEXIBLE_SELECTOR_HELP_TEXT_END" />
                                </SelectorHelpTriggerText>
                            </Tooltip>
                        </SelectorHelpWrap>
                        <Selector selectedMinDuration={selectedMinDuration} />
                        {inMixCartFlow && (
                            <Warning
                                text={<PureTranslator tk="MIX_FLEXIBLE_RENTAL_PLAN_WARNING" />}
                            />
                        )}
                        {canSubscribe && (
                            <Cta fullWidth color="red" onClick={onCtaClick}>
                                <PureTranslator tk={ctaTk} />
                            </Cta>
                        )}
                        {withTrialDescription && <TrialDescription price={price} />}
                        <Delivery
                            tinyText
                            preorderProduct={preorderProduct}
                            deliveryEstimation={deliveryEstimate}
                        />
                    </ContentWrap>
                ) : null}
            </Container>
        );
    },
);
